<ngx-json-ld [json]='{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Login",
    "description": "Log hier in op Bruiloft in je Broekzak."
}'></ngx-json-ld>

<div class="content-box content-box-responsive-single content-box-small">
  <h2>Log in</h2>
  <form bijbForm (bijbSubmit)="login()" novalidate>
    <table>
      <tr>
        <td class="align-right">Emailadres</td>
        <td class="align-left">
          <app-form-input-errors [input]="email"></app-form-input-errors>
          <input type="email" [(ngModel)]="credentials.email" name="email" id="email"
                 #email="ngModel" required email pattern=".*\S+.*" trim="blur" /></td>
      </tr>
      <tr>
        <td class="align-right">Wachtwoord</td>
        <td class="align-left">
          <app-form-input-errors [input]="password"></app-form-input-errors>
          <input type="password" [(ngModel)]="credentials.password" name="password" id="password"
                 #password="ngModel" required minlength="8" /></td>
      </tr>
    </table>
    <app-form-buttons [altLinkEnabled]="true"
                      [altLink]="'/demo-onboarding'"
                      [altLinkCaption]="'ik wil een account'"
                      [resetButtonEnabled]="false"
                      [updateButtonState]="false"
                      [busy]="busy"
                      [saveCaption]="'inloggen'"
                      [errorMessage]="error"></app-form-buttons>
    <br/>
    <a routerLink="/recover-account" class="button button-wide button-subtle">wachtwoord vergeten?</a>
  </form>
</div>
